import React, { useEffect, useState } from "react";
import {
  convertLocalDate,
  convertProfileLocalDate,
} from "../../Utils/configController";
import * as url from "../../helpers/url_helper";
import { useParams } from "react-router-dom";
import ReactDataTable from "../../components/Common/ReactDataTable";
import {
  Collapse,
  Card,
  CardBody,
  Col,
  Row,
  Spinner,
  Button,
  CardHeader,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useSocket } from "../../Utils/socket";
import { OPERATE_MQTT } from "../../helpers/socketEvent";
import { FormatJsonCheckBox } from "../../components/Common/button";
import Request from "../../helpers/request";
import OtaModal from "./Users/ProfileList/OtaModal";

const DebugDetail = () => {
  const socket: any = useSocket();
  const { slave } = useParams();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const [isReload, setReload] = useState(false);
  const [showFormatted, setShowFormatted] = useState<boolean>(false);
  const [txCount, setTxCount] = useState<number>(0);
  const [rxCount, setRxCount] = useState<number>(0);
  const [cmdCounts, setCmdCounts] = useState({});

  const [loading, setLoading] = useState<boolean>(false);
  const [profileDetails, setProfileDetails] = useState<any[]>([]);
  const [deviceDetails, setDeviceDetails] = useState<any>({});

  const [isOpen, setIsOpen] = useState(true);
  const [isOtaOpen, setIsOtaOpen] = useState(false);
  const [isSSModalOpen, setIsSSModalOpen] = useState(false);
  const [ssData, setSsData] = useState<any>(null);
  const [nodeSearch, setNodeSearch] = useState("");
  const [filterOnline, setFilterOnline] = useState(false);
  const [filterOffline, setFilterOffline] = useState(false);
  const [filterPowerOn, setFilterPowerOn] = useState(false);
  const [filterPowerOff, setFilterPowerOff] = useState(false);
  const handleSSClick = (command: string) => {
    try {
      const parsed = JSON.parse(command);
      setSsData(parsed);
      setIsSSModalOpen(true);
    } catch (e) {
      console.log("Failed to parse SS command", e);
    }
  };
  const toggle = () => setIsOpen(!isOpen);

  const getUsersDetail = () => {
    setLoading(true);
    const reqObj = {
      slave: slave,
    };
    Request.post(url.FINDUSERBYSLAVE, reqObj)
      .then((res) => {
        const data = res?.data?.userDetail;
        setDeviceDetails(res?.data?.deviceInfo);
        setProfileDetails([
          {
            name: "User Id",
            data: `#${data?.id}`,
          },
          {
            name: "Name",
            data: `${data?.firstname} ${data?.lastname}`,
          },
          {
            name: "Email",
            data: data?.email ? data?.email : "--",
          },
          {
            name: "Mobile",
            data: data?.mobile ? data?.mobile : "--",
          },
          {
            name: "Address",
            data: data?.address ? data?.address : "--",
          },
          {
            name: "Created At",
            data: data?.createdAt
              ? convertProfileLocalDate(data?.createdAt)
              : "--",
          },
          {
            name: "Last login",
            data: data?.lastLogin
              ? convertProfileLocalDate(data?.lastLogin)
              : "--",
          },
          {
            name: "Last Action",
            data: data?.lastAction
              ? convertProfileLocalDate(data?.lastAction)
              : "--",
          },
          {
            name: "Last Online Time",
            data: data?.lastOnlineTime
              ? convertProfileLocalDate(data?.lastOnlineTime)
              : "--",
          },
          {
            name: "Last Offline Time",
            data: data?.lastOfflineTime
              ? convertProfileLocalDate(data?.lastOfflineTime)
              : "--",
          },
        ]);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUsersDetail();
  }, [slave]);

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  const columns = [
    {
      name: "Command",
      cell: (row: any) => {
        try {
          const parsed = JSON.parse(row?.command);
          const cmd = parsed.cmd ? parsed.cmd : "-";

          const isTX = row.topic.includes("/TX") || row.topic.includes("/g2m");
          const isRX = row.topic.includes("/RX") || row.topic.includes("/m2g");

          const textColor = isTX ? "green" : isRX ? "orange" : "inherit";
          const isAirGateway =
            deviceDetails?.deviceType?.toLowerCase() === "airgateway";
          const isClickableSS = isAirGateway && cmd === "SS" && isTX;

          if (isClickableSS) {
            return (
              <div
                style={{
                  color: textColor,
                  cursor: "pointer",
                  fontWeight: 600,
                }}
                onClick={() => handleSSClick(row?.command)}
              >
                {cmd}
              </div>
            );
          }

          return <div style={{ color: textColor }}>{cmd}</div>;
        } catch (e) {
          return "-";
        }
      },
      selector: (row: any) => {
        try {
          const parsed = JSON.parse(row?.command);
          return parsed.cmd || "";
        } catch (e) {
          return "";
        }
      },
      sortable: true,
      wrap: true,
      grow: 0.5,
    },
    {
      name: `TX (${txCount})`,
      cell: (row: any) => {
        const isDevice =
          row.topic.includes("/TX") || row.topic.includes("/g2m");
        const content = isDevice
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
              lineHeight: "1.4",
              fontSize: "14px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },
    {
      name: `RX (${rxCount})`,
      cell: (row: any) => {
        const isMobile =
          row.topic.includes("/RX") || row.topic.includes("/m2g");
        const content = isMobile
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },

    {
      name: "Created At",
      selector: (row: any) => row.createdAt, // raw date value
      sortable: true,
      format: (row: any) => convertLocalDate(row.createdAt), // formatted display
      wrap: true,
    },
  ];
//  const isClickableSS = isAirGateway && cmd === "SS" && isTX;
  const formatCommand = (command: string) => {
    try {
      return JSON.stringify(JSON.parse(command), null, 2);
    } catch {
      return command;
    }
  };

  const handlePG = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "PG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Ping sent to slave ${slave}`);
    }
  };

  const handleDS = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DS",
      };

      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`DS sent to slave ${slave}`);
    }
  };
  const handleDL = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DL",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`DL sent to slave ${slave}`);
    }
  };
  const handleSS = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "SS",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`SS sent to slave ${slave}`);
    }
  };
  const handleGN = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "GN",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`GN sent to slave ${slave}`);
    }
  };
  const handleGG = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "GG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`GG sent to slave ${slave}`);
    }
  };
  const handleGC = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "GC",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`GC sent to slave ${slave}`);
    }
  };
  const handleReboot = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "HW",
        sub_cmd: "reboot",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Reboot sent to slave ${slave}`);
    }
  };

  const handleBSCH = () => {
    if (slave !== undefined && deviceDetails?.token) {
      const reqObj = {
        device_id: slave,
        cmd: "BSCH",
        sub_cmd: "get_info",
        tag: `airpanel-${userInfo?.id}`,
        token: deviceDetails?.token,
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`BSCH sent to slave ${slave}`);
    }
  };
  const handleBSCN = () => {
    if (slave !== undefined && deviceDetails?.token) {
      const reqObj = {
        device_id: slave,
        cmd: "BSCN",
        sub_cmd: "get_info",
        tag: `airpanel-${userInfo?.id}`,
        token: deviceDetails?.token,
      };

      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`BSCN sent to slave ${slave}`);
    }
  };
  const handleBRBT = () => {
    if (slave !== undefined && deviceDetails?.token) {
      const reqObj = {
        device_id: slave,
        cmd: "BRBT",
        tag: `airpanel-${userInfo?.id}`,
        token: deviceDetails?.token,
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`BRBT sent to slave ${slave}`);
    }
  };

  const openOtaModal = () => {
    if (!deviceDetails?.slave && !slave) {
      toast.error("Slave not found");
      return;
    }
    setIsOtaOpen(true);
  };
const filteredRows = (ssData?.data.node_id || [])
  .map((nodeId: any, idx: number) => ({ nodeId, idx }))
  .filter(({ nodeId }: any) =>
    String(nodeId).toLowerCase().includes(nodeSearch.toLowerCase())
  )
  .filter(({ idx }: any) => {
    const status = String(ssData.data.status?.[idx] ?? "");
    const isPowerOn = status.startsWith("1");
    const isOnline = status.endsWith("1");

    if (filterOnline && !isOnline) return false;
    if (filterOffline && isOnline) return false;
    if (filterPowerOn && !isPowerOn) return false;
    if (filterPowerOff && isPowerOn) return false;

    return true;
  });
  return (
    <>
      <ToastContainer />
      {isOtaOpen && (
        <OtaModal
          headerTitle="OTA Update"
          otaSlave={{
            ...deviceDetails,
            slave: deviceDetails?.slave || slave,
            product:
              deviceDetails?.deviceType === "blaster"
                ? "airblaster"
                : deviceDetails?.product?.toLowerCase(),
          }}
          cancleBtnClick={() => setIsOtaOpen(false)}
          isHideLog={true}
        />
      )}
      <Card
        style={{
          marginTop: 100,
          marginLeft: 30,
          marginRight: 30,
          marginBottom: 0,
        }}
      >
        <CardHeader
          className="d-flex justify-content-between align-items-center px-4 py-3"
          style={{
            backgroundColor: "#fff",
            borderBottom: isOpen ? "1px solid #e9ecef" : "none",
          }}
        >
          {/* LEFT */}
          <div className="">
            {(() => {
              const DEVICE_ACTIONS: Record<string, any[]> = {
                chip: [
                  { label: "PG", onClick: handlePG },
                  { label: "DS", onClick: handleDS },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                  {
                    label: "Reboot",
                    onClick: handleReboot,
                    color: "danger",
                  },
                ],
                blaster: [
                  { label: "BSCH", onClick: handleBSCH },
                  { label: "BSCN", onClick: handleBSCN },
                  { label: "BRBT", onClick: handleBRBT },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                ],
                aircurtain: [
                  { label: "PG", onClick: handlePG },
                  { label: "DS", onClick: handleDS },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                  {
                    label: "Reboot",
                    onClick: handleReboot,
                    color: "danger",
                  },
                ],
                iotdevice: [
                  { label: "PG", onClick: handlePG },
                  { label: "DS", onClick: handleDS },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                  {
                    label: "Reboot",
                    onClick: handleReboot,
                    color: "danger",
                  },
                ],
                airgateway: [
                  { label: "PG", onClick: handlePG },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "GN", onClick: handleGN },
                  { label: "GG", onClick: handleGG },
                  { label: "GC", onClick: handleGC },
                ],
              };
              const deviceType = deviceDetails?.deviceType?.toLowerCase();

              const actions = DEVICE_ACTIONS[deviceType || ""] || [];

              return (
                <div className="d-flex flex-wrap gap-3">
                  {actions.map((btn, index) => (
                    <button
                      key={index}
                      className={`btn btn-${btn.color || "dark"}`}
                      onClick={btn.onClick}
                      // disabled={!deviceDetails?.isOnline}
                    >
                      {btn.label}
                    </button>
                  ))}
                </div>
              );
            })()}
          </div>

          {/* RIGHT BUTTON */}
          <Button
            color="btn btn-dark"
            size="sm"
            onClick={toggle}
            className="  d-flex align-items-center gap-2"
          >
            <i
              className={`bx ${isOpen ? "bx-chevron-up" : "bx-chevron-down"}`}
              style={{ fontSize: "24px" }}
            ></i>
          </Button>
        </CardHeader>
        <Collapse isOpen={isOpen}>
          <CardBody>
            <Row>
              {profileDetails?.length > 0 && !loading ? (
                <>
                  <Col xs={12} md={3}>
                    {profileDetails
                      .slice(0, 5)
                      .map((item: any, index: number) => (
                        <p
                          key={index}
                          style={{ color: "#858D9D", fontSize: 14 }}
                          className="my-2"
                        >
                          {item?.name}:{" "}
                          {item?.name === "User Id" ? (
                            (() => {
                              const userId = item?.data?.startsWith("#")
                                ? item.data.slice(1)
                                : item?.data;

                              return (
                                <a
                                  href={`/users/profile/${userId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {item?.data}
                                </a>
                              );
                            })()
                          ) : (
                            <span style={{ fontWeight: "bold", color: "#000" }}>
                              {item?.data}
                            </span>
                          )}
                        </p>
                      ))}
                  </Col>
                  <Col xs={12} md={3}>
                    {profileDetails
                      .slice(5, 10)
                      .map((item: any, index: number) => (
                        <p
                          key={index}
                          style={{ color: "#858D9D", fontSize: 14 }}
                          className="my-2"
                        >
                          {item?.name}:{" "}
                          <span style={{ fontWeight: "bold", color: "#000" }}>
                            {item?.data}
                          </span>
                        </p>
                      ))}
                  </Col>
                  <Col xs={12} md={6}>
                    <Card className="shadow-sm border-1 mb-0">
                      {/* HEADER */}
                      <CardHeader className="d-flex justify-content-between align-items-center bg-white pt-3 px-3">
                        <div>
                          <h5 className="mb-0 fw-semibold d-flex align-items-center gap-2">
                            <i className="bx bx-chip"></i>
                            {deviceDetails.slave}
                            <span className="text-muted">
                              ({deviceDetails.deviceType})
                            </span>
                          </h5>
                        </div>

                        <Badge
                          color={deviceDetails.isOnline ? "success" : "danger"}
                        >
                          {deviceDetails.isOnline ? "Online" : "Offline"}
                        </Badge>
                      </CardHeader>

                      {/* BODY */}
                      <CardBody className="py-2 px-3">
                        <div className="row g-2" style={{ fontSize: "13px" }}>
                          {/* LEFT COLUMN */}
                          <div className="col-6 row g-1">
                            <div>
                              <strong>Product:</strong>{" "}
                              {deviceDetails.product || "--"}
                            </div>
                            <div>
                              <strong>Model:</strong>{" "}
                              {deviceDetails.modelType || "--"}
                            </div>

                            <div>
                              <strong>HW:</strong>{" "}
                              {deviceDetails.hwVersion || "--"}
                            </div>
                            <div>
                              <strong>WiFi:</strong>{" "}
                              {deviceDetails.wifiVersion || "--"}
                            </div>
                            <div>
                              <strong>Mcu Brand:</strong>{" "}
                              {deviceDetails.mcu_brand || "-"}
                            </div>
                          </div>

                          {/* RIGHT COLUMN */}
                          <div className="col-6 row g-1">
                            <div>
                              <strong>SSID:</strong>{" "}
                              {deviceDetails.ssid || "--"}
                            </div>
                            <div>
                              <strong>Signal:</strong>{" "}
                              <span
                                style={{
                                  color:
                                    deviceDetails.signalStrength > 80
                                      ? "green"
                                      : deviceDetails.signalStrength > 50
                                      ? "orange"
                                      : "red",
                                }}
                              >
                                {deviceDetails.signalStrength}%
                              </span>
                            </div>

                            <div>
                              <strong>THW:</strong> {deviceDetails.thw || "--"}
                            </div>
                            <div>
                              <strong>TSW:</strong> {deviceDetails.tsw || "--"}
                            </div>
                            <div>
                              <strong>RoomName:</strong> {deviceDetails.roomName || "--"}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </>
              ) : (
                <Col
                  xs={12}
                  md={12}
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "155px" }}
                >
                  <Spinner color="dark" />
                </Col>
              )}
            </Row>
          </CardBody>
        </Collapse>
      </Card>

      <Modal
        isOpen={isSSModalOpen}
        toggle={() => setIsSSModalOpen(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setIsSSModalOpen(false)}>
          <div className="d-flex gap-4 ">
           <div className=" pe-4 ">
             SS Command Data
            </div>
            <div className="d-flex justify-content-center align-items-center gap-1 ps-4">
              <input
                type="checkbox"
                checked={filterOnline}
                onChange={(e) => setFilterOnline(e.target.checked)}
              />
              <div className="text-muted small fs-6 fw-bold">Online</div>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-1">
              <input
                type="checkbox"
                checked={filterOffline}
                onChange={(e) => setFilterOffline(e.target.checked)}
              />
              <div className="text-muted small fs-6 fw-bold">Offline</div>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-1">
              <input
                type="checkbox"
                checked={filterPowerOn}
                onChange={(e) => setFilterPowerOn(e.target.checked)}
              />
              <div className="text-muted small fs-6 fw-bold">Power ON</div>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-1">
              <input
                type="checkbox"
                checked={filterPowerOff}
                onChange={(e) => setFilterPowerOff(e.target.checked)}
              />
              <div className="text-muted small fs-6 fw-bold">Power OFF</div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {ssData?.data ? (
            <>
              {/* Search Node ID */}
              <div className="row g-2 mb-3">
                <div className="col">
                  <div className="border rounded p-2 text-center bg-light">
                    <div className="text-muted small fs-6 fw-bold">
                      Total Nodes
                    </div>
                    <div className="fw-bold fs-4">{ssData?.data?.total}</div>
                  </div>
                </div>

                <div className="col">
                  <div className="border rounded p-2 text-center">
                    <div className="text-muted small fs-6 fw-bold">Online</div>
                    <div className="fw-bold fs-4 text-success">
                      {
                        ssData.data.status.filter((status: any) =>
                          String(status).endsWith("1"),
                        ).length
                      }
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="border rounded p-2 text-center">
                    <div className="text-muted small fs-6 fw-bold">Offline</div>

                    <div className="fw-bold fs-4 text-danger">
                      {
                        ssData.data.status.filter((status: any) =>
                          String(status).endsWith("0"),
                        ).length
                      }
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="border rounded p-2 text-center">
                    <div className="text-muted small fs-6 fw-bold">
                      Power ON
                    </div>
                    <div className="fw-bold fs-4 text-success">
                      {
                        ssData.data.status.filter((status: any) =>
                          String(status).startsWith("1"),
                        ).length
                      }
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="border rounded p-2 text-center">
                    <div className="text-muted small fs-6 fw-bold">
                      Power OFF
                    </div>
                    <div className="fw-bold fs-4 text-danger">
                      {
                        ssData.data.status.filter((status: any) =>
                          String(status).startsWith("0"),
                        ).length
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <div className="input-group">
                  <span className="input-group-text bg-white">
                    <i className="bx bx-search"></i>
                  </span>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Node ID..."
                    value={nodeSearch}
                    onChange={(e) => setNodeSearch(e.target.value)}
                  />

                  {nodeSearch && (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setNodeSearch("")}
                    >
                      <i className="bx bx-x"></i>
                    </button>
                  )}
                </div>
              </div>

              <div
                className="table-responsive"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                <table className="table table-bordered table-sm mb-2">
                  <thead>
                    <tr>
                      <th>Node ID</th>
                      <th>Brightness</th>
                      <th>Temp</th>
                      <th>Status</th>
                      <th>Power</th>
                      <th>Connection</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredRows?.map(({ nodeId, idx }: any) => {
                      const status = String(ssData.data.status?.[idx] ?? "");
                      const isPowerOn = status.startsWith("1");
                      const isOnline = status.endsWith("1");

                      return (
                        <tr key={idx}>
                          <td className="fw-semibold">{nodeId}</td>
                          <td>{ssData.data.brightness?.[idx] ?? "--"}</td>
                          <td>{ssData.data.temp?.[idx] ?? "--"}</td>
                          <td>{status || "--"}</td>
                          <td>
                            <span
                              className={`fw-semibold ${
                                isPowerOn ? "text-success" : "text-danger"
                              }`}
                            >
                              {isPowerOn ? "ON" : "OFF"}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`fw-semibold ${
                                isOnline ? "text-success" : "text-danger"
                              }`}
                            >
                              {isOnline ? "Online" : "Offline"}
                            </span>
                          </td>
                        </tr>
                      );
                    })}

                    {filteredRows.length === 0 && (
                      <tr>
                        <td colSpan={6} className="text-center text-muted py-3">
                          No Node ID found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div>No data available</div>
          )}

          <div style={{ fontSize: 13, color: "#858D9D" }}>
            Device ID: {ssData?.device_ID || "--"} &nbsp;|&nbsp; Serial:{" "}
            {ssData?.serial ?? "--"} &nbsp;|&nbsp; Error:{" "}
            {ssData?.error ?? "--"} &nbsp;|&nbsp; Total Node: {filteredRows.length}
          </div>
        </ModalBody>
      </Modal>
      <ReactDataTable
        apiURL={`${url.BASE_URL}${url.DEBUG_DETAIL_LIST}`}
        paramsId={{ slave: slave }}
        columns={columns}
        isReload={isReload}
        setTxCount={setTxCount}
        setRxCount={setRxCount}
        setCmdCounts={setCmdCounts}
        cmdList={
          <div
            className="d-flex flex-wrap"
            style={{ gap: "12px", fontSize: "16px" }}
          >
            {Object.entries(cmdCounts as { [key: string]: number })
              ?.sort(([a], [b]) => {
                if (a === "ERROR") return 1;
                if (b === "ERROR") return -1;
                if (a === "NO CMD") return 1;
                if (b === "NO CMD") return -1;
                return a.localeCompare(b);
              })
              ?.map(([cmd, count], i) => (
                <div
                  key={`${cmd}-${i}`}
                  className={`d-flex justify-content-center align-items-center border gap-2 px-2 py-2 ${
                    cmd === "ERROR"
                      ? "bg-danger text-white rounded"
                      : "bg-light rounded"
                  }`}
                  style={{
                    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                  }}
                >
                  <small className="text-uppercase fw-semibold">
                    {cmd === "ERROR" ? "ERRORS" : cmd}
                  </small>
                  <span className="badge bg-primary rounded-pill ">
                    {count}
                  </span>
                </div>
              ))}
          </div>
        }
        buttonformatJSON={
          <FormatJsonCheckBox
            checked={showFormatted}
            onChange={() => setShowFormatted(!showFormatted)}
          />
        }
      />
    </>
  );
};

export default DebugDetail;
